import React from 'react';
import Screen from '../../assets/landing/Feed.png';
import './styles.scss';

export const LandingPage = (props) => {
  return (
    <div className="page">
      <div className="landing-container">
        <div className="dartmate-description">
          <h1 className="dartmate">DartMate</h1>
          <h2 className="description">Making the roommate matching process as seamless as possible.</h2>
        </div>
      </div>
      <div className="landing-2">
        <div className="top-third">Research shows that a lucky roommate match can lead to...</div>
        <div className="middle-third">
          <div className="boxes" id="one">
            <div className="top-text">40%</div>
            <div className="bottom-text">Increase in fitness levels</div>
          </div>
          <div className="boxes" id="two">
            <div className="top-text">67%</div>
            <div className="bottom-text">Reduction in roommate transfers</div>
          </div>
          <div className="boxes" id="two">
            <div className="top-text">0.11</div>
            <div className="bottom-text">Increase in GPA</div>
          </div>
          <div className="boxes" id="two">
            <div className="top-text">9%</div>
            <div className="bottom-text">Increase in overall happiness</div>
          </div>
        </div>
        <div className="bottom-third">...so why leave it to luck?</div>
      </div>
      <div className="landing-3">
        <div className="left2">
          <div className="text">
            Find your roommate love story with DartMate.
          </div>
        </div>
        <div className="right2">
          <div className="background-radial">
            <div className="screenshot">
              <img id="picture2" src={Screen} alt="Profile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
